import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
} from "./constants";

import enTranslation from "./locales/en/translation.json";
import caTranslation from "./locales/ca/translation.json";
import esTranslation from "./locales/es/translation.json";

const resources = {
  en: { translation: enTranslation },
  ca: { translation: caTranslation },
  es: { translation: esTranslation },
};

function getInitialLanguage() {
  if (typeof window === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  const persisted = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (persisted) {
    return normalizeLanguage(persisted);
  }

  const browserLanguage =
    window.navigator.languages?.[0] || window.navigator.language;
  return normalizeLanguage(browserLanguage);
}

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  debug: false,
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language || DEFAULT_LANGUAGE;
}

i18n.on("languageChanged", (language) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
});

export default i18n;
